import { render, staticRenderFns } from "./editaline.vue?vue&type=template&id=ceff4cc6&scoped=true&"
import script from "./editaline.vue?vue&type=script&lang=js&"
export * from "./editaline.vue?vue&type=script&lang=js&"
import style0 from "./editaline.vue?vue&type=style&index=0&id=ceff4cc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceff4cc6",
  null
  
)

export default component.exports